import SearchableTable from './SearchableTable'

export default SearchableTable
